import { ErrorMessage, Field, Form, Formik } from 'formik';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import WarningDialog2 from './WarningDialog2';
import Swal from 'sweetalert2';

const schema = Yup.object().shape({
  UTR: Yup.string().required('Please Enter UTR number')
});

const InfoFormBlue = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const data = JSON.parse(atob(id));

  useEffect(() => {
    document.title = data?.ap;
    if (data?.e < moment().unix()) return navigate('/expire');
  }, [navigate, data?.e, data?.ap]);

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    Swal.fire({
      title: 'Copied',
      confirmButtonColor: '#79CBF2',
      confirmButtonText: 'Ok',
      reverseButtons: true
    });
  };

  return (
    <div
      className='container-sm'
      style={{ maxWidth: '1100px', minHeight: '100vh', paddingTop: '3rem' }}
    >
      <div className='head'>
        <img src='/images/upi.png' alt='upi' style={{ width: '150px' }} />
      </div>
      <div className='box-blue'>
        <div className='box-head-blue'>
          <p>Step1:Copy UPI information</p>
        </div>
        <div className='box-body-blue'>
          <p>Name:</p>
          <p>{data?.u}</p>
        </div>
        <div className='box-body-blue'>
          <p>Amount</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
            <p>{data?.a}</p>
            <button
              style={{
                border: '1px solid gray',
                borderRadius: '2px',
                padding: '.2rem .5rem',
                lineHeight: '0.9'
              }}
              onClick={() => handleCopy(data?.a)}
            >
              Copy
            </button>
          </div>
        </div>
        <div className='box-body-blue' style={{ marginBottom: '1rem' }}>
          <p>VPA/UPI:</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
            <p>{data?.up}</p>
            <button
              style={{
                border: '1px solid gray',
                borderRadius: '2px',
                padding: '.2rem .5rem',
                lineHeight: '0.9'
              }}
              onClick={() => handleCopy(data?.up)}
            >
              Copy
            </button>
          </div>
        </div>
      </div>
      <div className='box-head-blue' style={{ marginBottom: '1rem' }}>
        <p>Step2:Transfer and don’t modify this amount to us.</p>
      </div>
      <div className='box-body-blue'>
        <p>{`Please record your reference No {.Ref No.} after payment`}</p>
      </div>
      <div className='box-head-blue' style={{ marginBottom: '1rem' }}>
        <p>Step3:Please enter Ref No. to complete the recharge</p>
      </div>
      <div className='box-body-blue'>
        <p>
          Be sure to return this page to fill the UTR numbers after you have
          completed your payment
        </p>
      </div>
      <Formik
        initialValues={{ UTR: '' }}
        validationSchema={schema}
        onSubmit={() => {
          Swal.fire({
            icon: 'success',
            title: 'Successfully!',
            text: 'Your payement will take 30 Minutes for a Review.',
            confirmButtonColor: '#79CBF2',
            confirmButtonText: 'Ok',
            reverseButtons: true
          });
        }}
      >
        {({ errors }) => (
          <Form>
            <Field
              name='UTR'
              className='text-ellipsis mt-2'
              style={{
                border: `2px solid ${
                  !!errors.UTR ? 'rgb(185, 74, 72)' : 'lightgray'
                }`,
                width: '100%',
                padding: '0.5rem 1rem'
              }}
            />
            {console.log(!!errors.UTR)}
            <button type='submit' className='mt-2 submit-btn-2'>
              Submit UTR
            </button>
            <ErrorMessage
              component='div'
              name='UTR'
              style={{ textAlign: 'left' }}
            />
          </Form>
        )}
      </Formik>
      <p className='color-gray'>
        © 2023 Fastpay Technical Support. All Rights Reserved.
      </p>
      <WarningDialog2 />
      <div className='head'>
        <img src='/images/upi.png' alt='upi' style={{ width: '150px' }} />
      </div>
    </div>
  );
};

export default InfoFormBlue;
